

module.exports = {
  "./locales/de/common.json": (function() { var id = 99378; return __webpack_require__.t(id, 3); })(),
  "./locales/en/common.json": (function() { var id = 79802; return __webpack_require__.t(id, 3); })(),
  "./locales/es/common.json": (function() { var id = 47067; return __webpack_require__.t(id, 3); })(),
  "./locales/fr-fr/common.json": (function() { var id = 11976; return __webpack_require__.t(id, 3); })(),
  "./locales/fr/common.json": (function() { var id = 50227; return __webpack_require__.t(id, 3); })(),
  "./locales/it/common.json": (function() { var id = 11140; return __webpack_require__.t(id, 3); })(),
  "./locales/nl/common.json": (function() { var id = 38221; return __webpack_require__.t(id, 3); })(),
  "./locales/pl/common.json": (function() { var id = 93579; return __webpack_require__.t(id, 3); })()
};
